<div class="applicationheader">
  <div class="applicationheader__image">
    <ng-content></ng-content>
    </div>
</div>
